export default __webpack_public_path__ + "static/media/udaan.5c5c265d.png";